import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLicense } from '../../_helper/LicenseContext';
import { Badge, Row, Col, Card } from 'reactstrap'; // assuming you're using reactstrap
import { Calendar, CheckCircle, Users, Mail, MessageCircle } from 'react-feather';
// import { t } from your translation function if needed
import { format, parseISO } from 'date-fns';
import Swal from 'sweetalert2';
import { getMessageCount, upgradPlan } from '../LabProfile/service/profile-service';
import Modal from "react-bootstrap/Modal";
import { useLab } from '../../_helper/PharmacyProvider';
import { toast } from "react-toastify";
import { Label } from "reactstrap";
import { Button } from "react-bootstrap";
import { useLoader } from '../../_helper/LoaderContext';

export default function HomePlan() {
  const { t } = useTranslation();
  const { decodeTokenOnly, saveLicenseToken } = useLicense();
  const [features, setFeatures] = useState([]); // We'll store array of { name, value }
  const [loadings, setLoadings] = useState(true);
  const [data, setData] = useState({})
  const [licenseKey, setLicenseKey] = useState("");
  const [show1, setShow1] = useState(false);
  const [error, setError] = useState("");
  const { currentLab, setCurrentLab } = useLab();
  const keyLicense = localStorage.getItem("licenseKey");
  const [count, setCount] = useState({})
  const { setLoading } = useLoader();

  useEffect(() => {
    decodeTokenOnly()
      .then((decoded) => {
        // console.log(decoded);
        setData(decoded)
        if (decoded?.features && typeof decoded.features === 'object') {
          // Convert features object into array of { key, value }
          const featureList = Object.keys(decoded.features).map((key) => ({
            name: key
              .split('_')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' '), // Convert snake_case to Title Case
            value: decoded.features[key],
            rawKey: key,
          }));

          setFeatures(featureList);
        } else {
          setFeatures([]);
        }
      })
      .catch((err) => {
        console.error('Failed to decode token:', err);
        setFeatures([]);
      })
      .finally(() => {
        setLoadings(false);
      });
  }, [decodeTokenOnly]);

  useEffect(() => {
    getData();
  },[])

  // Helper to format value display
  const formatValue = (value) => {
    if (typeof value === 'boolean') {
      return value ? t('Enabled') : t('Disabled');
    }
    return value ? String(value).charAt(0).toUpperCase() + String(value).slice(1) : t('N/A');
  };

  const formatDateTime = (isoString) => {
    if (!isoString) return t('N/A');
    try {
      const date = parseISO(isoString);
      return format(date, 'dd/MM/yyyy \'at\' hh:mm a');
      // Output: 01/01/2026 at 11:29 AM
    } catch {
      return t('Invalid Date');
    }
  };

  const formatExpiresAt = (timestampMs) => {
    if (!timestampMs) return t('N/A');

    const date = new Date(timestampMs);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

    return `${day}/${month}/${year} at ${hours}:${minutes} ${ampm}`;
  };

  const OpenUpdateModal = () => {
    setShow1(true);
  }

  const handleUpdate = async () => {
    if (licenseKey == "") {
      setError(t("Please enter license key"))
      return
    }
    if (currentLab.licenseKey == licenseKey.trim()) {
      setError("")
      Swal.fire({
        icon: 'info',
        text: t("Please Enter new license key")
      })
    } else {
      setError("")
      Swal.fire({
        icon: 'info',
        title: t("Are you sure?"),
        text: t('Changing your plan may impact available features and limits. Please confirm to proceed.'),
        showCancelButton: true,
        confirmButtonText: t("Yes, Upgrade"),
        cancelButtonText: t("Cancel"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true)
          try {
            //  const licesnse = localStorage.getItem("licenseKey")
            const payload = {
              oldLicenseKey: keyLicense,
              newLicenseKey: licenseKey,
              user: {
                id: currentLab._id,
                name: currentLab.contact_person.first_name + " " + currentLab.contact_person.last_name,
              }
            }
            const res = await upgradPlan(payload);
            if (res.data.success == true) {
              toast.success(res.data.message);
              localStorage.setItem("licenseKey", licenseKey)
              setLicenseKey("")
              await saveLicenseToken(res.data.data.data.token);
              setShow1(false);
            }
          } catch (error) {
            console.log(error)
          } finally {
            setLoading(false)
          }
        }
      })
    }
  };

  const getData = async () => {
    setLoading(true);
    try {
      const res = await getMessageCount()
      if (res.data.success == true) {
        setCount(res.data.data)
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false)
    }
  }
  return (
    <>
      {/* Features Section */}
      <Card>
        <div className="">
          <div className="p-4">
            <div className="row">
              <div className="col-md-8">
                <h5 className="fw-bold tw-text-[#1b255b] mb-4 d-flex align-items-center">
                  {data?.plan?.name} <span className='ms-2 tw-text-sm tw-bg-[#1b255b] tw-text-[#ffc745] px-2 tw-rounded-xl'>{data?.plan?.packageLevel}</span>
                </h5>
              </div>
              <div className="col-md-4 tw-text-end" onClick={OpenUpdateModal}>
                <Button variant="primary">{t("Upgrade Plan")}</Button>
              </div>
            </div>
            <Row>
              <Col md={6} lg={4} className='mb-3'>
                <div className="d-flex align-items-start">
                  <Calendar className="text-success me-2 flex-shrink-0 mt-1" size={18} />
                  <div>
                    <span className="fw-bold d-block">{t("Activated Date")}</span>
                    <small className="text-muted">
                      {formatDateTime(data?.activatedAt)}
                    </small>
                  </div>
                </div>
              </Col>
              <Col md={6} lg={4} className='mb-3'>
                <div className="d-flex align-items-start">
                  <Calendar className="text-success me-2 flex-shrink-0 mt-1" size={18} />
                  <div>
                    <span className="fw-bold d-block">{t("Expiry Date")}</span>
                    <small className="text-muted">
                      {formatExpiresAt(data?.expiresAt)}
                    </small>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="d-flex align-items-start">
                  <Users className="text-success me-2 flex-shrink-0 mt-1" size={18} />
                  <div>
                    <span className="fw-bold d-block">{t("Allowed Users")}</span>
                    <small className="text-muted">
                      {data?.limitations?.users_allowed}  <span className='tw-text-green-500'>({count.subAdminCount} {t("onboarded")})</span>
                    </small>
                  </div>
                </div>
              </Col>
            </Row>
            {loadings ? (
              <div>{t("loading features...")}</div>
            ) : features.length > 0 ? (
              <Row>
                {/* <Col md={6} lg={4} className='mb-3'>
                  <div className="d-flex align-items-start">
                    <Calendar className="text-success me-2 flex-shrink-0 mt-1" size={18} />
                    <div>
                      <span className="fw-bold d-block">Activated Date</span>
                      <small className="text-muted">
                        {formatDateTime(data?.activatedAt)}
                      </small>
                    </div>
                  </div>
                </Col>
                <Col md={6} lg={4} className='mb-3'>
                  <div className="d-flex align-items-start">
                    <Calendar className="text-success me-2 flex-shrink-0 mt-1" size={18} />
                    <div>
                      <span className="fw-bold d-block">Expiry Date</span>
                      <small className="text-muted">
                        {formatExpiresAt(data?.expiresAt)}
                      </small>
                    </div>
                  </div>
                </Col> */}

                {features.map((feature, index) => (
                  <Col md={6} lg={4} key={index} className="mb-3">
                    <div className="d-flex align-items-start">
                      <CheckCircle className="text-success me-2 flex-shrink-0 mt-1" size={18} />
                      <div>
                        <span className="fw-bold d-block">{t(feature.name)}</span>
                        <small className="text-muted">
                          {formatValue(feature.value)}
                        </small>
                      </div>
                    </div>
                  </Col>
                ))}
                {/* <Col>
                  <div className="d-flex align-items-start">
                    <Users className="text-success me-2 flex-shrink-0 mt-1" size={18} />
                    <div>
                      <span className="fw-bold d-block">Allowed Users</span>
                      <small className="text-muted">
                        {data?.limitations?.users_allowed}
                      </small>
                    </div>
                  </div>
                </Col> */}
              </Row>
            ) : (
              <p className="text-muted mb-0">{t("No features available")}</p>
            )}
            <Row>
              <Col md={6} lg={4}>
                <div className="d-flex align-items-start">
                  <Mail className="text-success me-2 flex-shrink-0 mt-1" size={18} />
                  <div>
                    <span className="fw-bold d-block">{t("Allowed Email Limit")}</span>
                    <small className="text-muted">
                      {data?.limitations?.email_limit} <span className='tw-text-green-500'>({count.emailSent} {t("Used")})</span>
                    </small>
                  </div>
                </div>
              </Col>
              <Col md={6} lg={4}>
                <div className="d-flex align-items-start">
                  <MessageCircle className="text-success me-2 flex-shrink-0 mt-1" size={18} />
                  <div>
                    <span className="fw-bold d-block">{t("Allowed WhatsApp Limit")}</span>
                    <small className="text-muted">
                      {data?.limitations?.whatsapp_limit} <span className='tw-text-green-500'>({count.whatsappSent} {t("Used")})</span>
                    </small>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Card>

      <Modal show={show1} onHide={() => setShow1(false)} centered>
        <Modal.Header>
          <Modal.Title>{t("Upgrade Plan")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="">{t("Current License Key")}: <span className='tw-font-bold'>{keyLicense}</span></div>
          <div className="form-group mt-2">
            <Label>{t("License Key")}</Label>
            <input
              type="text"
              className="form-control"
              placeholder={t("Enter new license key")}
              value={licenseKey}
              onChange={(e) => setLicenseKey(e.target.value)}
            />
            <span className="tw-text-red-500">{error}</span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleUpdate}>
            {t("Upgrade")}
          </Button>
          <Button variant="secondary" onClick={() => setShow1(false)}>
            {t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
}